import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetUserFailed, EGetUserActionTypes } from './types';

export const getUserFailed: () => TGetUserFailed = actionGenerator<EGetUserActionTypes.Failed>(
  EGetUserActionTypes.Failed,
);
